import pageTitle from '@/components/titleView.vue'
import { titleObj } from '@/utils/page_setting'
import About from '../views/about.vue'
import System from '@/views/system.vue'
import Case from '@/views/case.vue'
import Contact from '@/views/contact.vue'

const mainRoutes = [
  {
    path: '/',
    name: 'Home',
    redirect: { name: 'about' }
  },
  {
    path: '/about',
    name: 'about',
    components: {
      default: About,
      title: pageTitle
    },
    props: {
      default: false,
      title: titleObj.about
    },
    meta: {
      title: '嗨支付-公司简介'
    }
  },
  {
    path: '/system',
    name: 'system',
    components: {
      default: System,
      title: pageTitle
    },
    props: {
      default: false,
      title: titleObj.system
    },
    meta: {
      title: '嗨支付-支付系统'
    }
  },
  {
    path: '/case',
    name: 'case',
    components: {
      default: Case,
      title: pageTitle
    },
    props: { default: false, title: titleObj.case },
    meta: {
      title: '嗨支付-成功案例'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    components: {
      default: Contact,
      title: pageTitle
    },
    props: {
      default: false,
      title: titleObj.contact
    },
    meta: {
      title: '嗨支付-联系我们'
    }
  }
]

export default mainRoutes
